import React from 'react';
import ComponentErrorBoundary from 'core/modules/ErrorBoundaries/ComponentErrorBoundary';

import config from '../configs';

function InstoreOnlyPill() {
  const { instoreOnlyPillText } = config;

  return <div className="mn_instoreOnlyPill">{instoreOnlyPillText}</div>;
}

export default (props) => <ComponentErrorBoundary><InstoreOnlyPill {...props} /></ComponentErrorBoundary>;
